import { useEffect, useRef, useState } from "react";
import $ from "jquery";
// import timelineImage from "assets/hm_service_image/Timeline_2025.png";
import image8 from "assets/hm_service_image/MHSD_footer.png";
import image9 from "assets/hm_service_image/MHSDmb.png";
import ModalProduct from "./ModalProduct";
import { PhoneConfigs } from "./constant";
// import change from "assets/hm_service_image/change.png";
// import changemb from "assets/hm_service_image/change.png";
import Slider from "react-slick";
import homebn from "assets/hm_service_image/bannerldp33.png";
import homebnmb from "assets/hm_service_image/homebnmb.png";
import duoPC from "assets/hm_service_image/duoPC.png";
import duoMB from "assets/hm_service_image/duoMB.png";
import {
  iPhone18Pro,
  iPhone18ProMax,
  iPhoneDuo,
  watchUltra4,
  watchSeries12Gps,
  watchSeries12Cellular,
} from "config/productItems";
import { ProductSection } from "pages/ComingSoon/components";
// import { MODEL_KEY } from "config/products";
// import CountDown from "pages/ComingSoon/components/CountDown";
// import BlankLink from "components/shared/BlankLink";
// import HomeBannerPromotion from "components/shared/HomeBannerPromotion";
import { HomeStyled } from "styles/homeStyled";
import Airpods from "pages/ComingSoon/components/Airpods";
import InfoTabs from "pages/ComingSoon/components/InfoTabs";
import { Helmet } from "react-helmet";
import { META_CONFIG_18 } from "utils/contants";
import ModalRegistration from "pages/ComingSoon/ModalRegistration";

import branch from "assets/hm_service_image/branch.png";
import branch2 from "assets/hm_service_image/branch2.png";
import branch3 from "assets/hm_service_image/branch3.png";
import branch7 from "assets/hm_service_image/branch7.png";
import branch6 from "assets/hm_service_image/branch6.png";
import branch4 from "assets/hm_service_image/branch4.png";
import { getTimeNow } from "services/pre-order.service";
import WatchUltra4Section from "pages/ComingSoon/components/WatchUltra4Section";
// import HomeBannerPromotion from "components/shared/HomeBannerPromotion";

function Home() {
  const [openModal, setOpenModal] = useState(false);
  const [productConfigs, setProductConfigs] = useState(PhoneConfigs);
  const [openRegistration, setOpenRegistration] = useState(false);
  const [regProductId, setRegProductId] = useState(null);
  // const [openiPhoneModal, setOpeniPhoneModal] = useState(false);
  const [isPreDuo, setIsPreDuo] = useState(false);
  const [selectiPadAirM3, setSelectiPadAirM3] = useState(1);
  const [isTimeChecked, setIsTimeChecked] = useState(false);

  const iPhoneProMaxRef = useRef(null);
  const iPhoneDuoRef = useRef(null);

  useEffect(() => {
    $(document).ready(function () {
      $(window).scroll(function () {
        var navLink = $(".nav-link");

        if ($(window).scrollTop() > 1000) {
          navLink.addClass("sticky");
        } else {
          navLink.removeClass("sticky");
        }
      });
    });
    // loadTotalPreOrder();
  }, []);

  const handleScrollToProduct = (productRef) => {
    productRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const handleOpenRegistration = (productId) => {
    const overlay = document.getElementById("overlay");
    document.body.style.overflow = "hidden";
    overlay.style.display = "block";
    setOpenRegistration(true);
    setRegProductId(productId);
  };

  const handleCloseModal = () => {
    const overlay = document.getElementById("overlay");
    overlay.style.display = "none";
    document.body.style.overflow = "auto";
    setOpenRegistration(false);
  };

  const path = window.location.pathname;
  const meta = META_CONFIG_18[path];

  const scrollTargetRef = useRef(null);

  // thêm config riêng cho list-branch
  const sliderSettingsBranch = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1800,
    responsive: [
      {
        breakpoint: 1024, // tablet
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // mobile
        settings: {
          slidesToShow: 1.6,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (window.location.href.includes("scrollwatch")) {
      setTimeout(() => {
        scrollTargetRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 200);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (params.has("iphone-duo")) {
      const timer = setTimeout(() => {
        iPhoneDuoRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 300);

      return () => clearTimeout(timer);
    }

    if (params.has("watch")) {
      const timer = setTimeout(() => {
        scrollTargetRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 300);

      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    let duoTimeout;

    const checkPreDuoTime = async () => {
      try {
        const getTimeVNServer = await getTimeNow();
        const serverTime = new Date(getTimeVNServer?.time);
        const targetTime = new Date("2026-10-16T19:00:00+07:00");
        const diff = targetTime.getTime() - serverTime.getTime();

        if (diff <= 0) {
          setIsPreDuo(true);
        } else {
          setIsPreDuo(false);

          duoTimeout = setTimeout(() => {
            window.location.reload();
          }, diff);
        }
      } catch (error) {
        console.error("Get server time for Duo failed:", error);
      } finally {
        setIsTimeChecked(true);
      }
    };

    checkPreDuoTime();
    return () => {
      if (duoTimeout) clearTimeout(duoTimeout);
    };
  }, []);

  const handleSiPadAirM311Inch = (value) => {
    setSelectiPadAirM3(value);
  };

  return (
    <HomeStyled>
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          {meta?.title || "iPhone 18 Pro Series có giá từ 38 triệu, đủ 4 màu"}
        </title>
        <meta
          name="description"
          content={
            meta?.description ||
            "iPhone 18 Pro Series gồm iPhone 18 Pro và iPhone 18 Pro Max, dung lượng 256GB, 512GB, 1TB, 2TB; 4 màu Đen, Bạc, Xanh và Đỏ Burgundy. Giá từ 38 triệu tại ShopDunk."
          }
        />

        <meta name="robots" content={meta?.robots}></meta>
        <meta property="og:locale" content={meta?.openGraph?.locale}></meta>
        <meta property="og:url" content={meta?.openGraph?.url}></meta>
        <meta property="og:type" content={meta?.openGraph?.type}></meta>
        <meta property="og:title" content={meta?.openGraph?.title}></meta>
        <meta
          property="og:description"
          content={meta?.openGraph?.description}
        ></meta>
        <meta
          property="og:site_name"
          content={meta?.openGraph?.siteName}
        ></meta>
        {/* <meta  property="og:site_name" content={meta?.openGraph?.image}></meta> */}

        <meta property="twitter:title" content={meta?.twitter?.title}></meta>
        <meta
          property="twitter:description"
          content={meta?.twitter?.description}
        ></meta>
        <meta property="twitter:card" content={meta?.twitter?.card}></meta>
        {/* <meta  property="twitter:image" content={meta?.twitter?.image}></meta> */}

        <link rel="canonical" href={window.location.href} />

        {/* <script type="application/ld+json">
          {meta?.schema}
        </script> */}
      </Helmet>
      <div className="pre-order-page">
        <div className="page pre-home-page">
          <div className="home-banner home-banner-rp">
            <div className="content-home-banner">
              {/* Banner */}
              {isTimeChecked && (
                isPreDuo ? (
                  <>
                    <img
                      style={{ cursor: "pointer" }}
                      src={duoPC}
                      alt=""
                      width="100%"
                      className="f-desktop"
                      onClick={() => handleScrollToProduct(iPhoneDuoRef)}
                    />

                    <img
                      src={duoMB}
                      alt=""
                      width="100%"
                      className="f-mb"
                      onClick={() => handleScrollToProduct(iPhoneDuoRef)}
                    />
                  </>
                ) : (
                  <>
                    <img
                      style={{ cursor: "pointer" }}
                      src={homebn}
                      alt=""
                      width="100%"
                      className="f-desktop"
                      onClick={() => handleScrollToProduct(iPhoneProMaxRef)}
                    />

                    <img
                      src={homebnmb}
                      alt=""
                      width="100%"
                      className="f-mb"
                      onClick={() => handleScrollToProduct(iPhoneProMaxRef)}
                    />
                  </>
                )
              )}
              {/* Banner */}

              {/* <HomeBannerPromotion /> */}
              <div className="content-home-banner content-home-banner-rp">
                {/* <CountDown /> */}
                <div className="hero-bgimage">
                  {/* <div className="btn_deposit" style={{ visibility: 'hidden' }}>
                  </div> */}
                  {/* <button
                    type="button"
                    className="btn_deposit"
                    onClick={() => {
                      iPhoneProMaxRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}
                  >
                    Đặt cọc ngay
                  </button> */}
                </div>
              </div>
            </div>
          </div>

          <section className="pre-timeline">
            {/* <ul className="nav-link">
              <li>
                <a href="#uu-dai" className="active">
                  Ưu đãi
                </a>
              </li>
              <li>
                <a href="https://shopdunk.com/thu-cu-doi-moi" target="_blank" rel="noreferrer">Thu cũ</a>
              </li>
              <li>
                <a href="https://compare.shopdunk.com/assets/iphone/index.html" target="_blank" rel="noreferrer">So sánh</a>
              </li>
              <li>
                <a href="https://shopdunk.com/tra-gop-apple-shopdunk" target="_blank" rel="noreferrer">Trả góp</a>
              </li>
            </ul> */}

            <div className="content-timeline">
              <div className="info-timeline" id="uu-dai">
                {/* <img src={timelineImage} alt="" width="100%" style={{ marginBottom: '60px' }} /> */}
                {/* <img src={change} alt="" width="100%" className="f-desktop" />
                <img src={changemb} alt="" width="100%" className="f-mb pd20" /> */}
              </div>
            </div>

            <div className="content-branch">
              <Slider {...sliderSettingsBranch} className="list-branch">
                <div className="branch-item">
                  <a
                    href="https://shopdunk.com/khuyen-mai"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Xem khuyến mãi"
                  >
                    <img src={branch7} alt="" width="100%" />
                  </a>
                </div>
                <div className="branch-item">
                  <a
                    href="https://shopdunk.com/khuyen-mai"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Xem khuyến mãi"
                  >
                    <img src={branch} alt="" width="100%" />
                  </a>
                </div>
                <div className="branch-item">
                  <a
                    href="https://shopdunk.com/khuyen-mai"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Xem khuyến mãi"
                  >
                    <img src={branch2} alt="" width="100%" />
                  </a>
                </div>
                <div className="branch-item">
                  <a
                    href="https://shopdunk.com/khuyen-mai"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Xem khuyến mãi"
                  >
                    <img src={branch3} alt="" width="100%" />
                  </a>
                </div>
                <div className="branch-item">
                  <a
                    href="https://shopdunk.com/khuyen-mai"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Xem khuyến mãi"
                  >
                    <img src={branch4} alt="" width="100%" />
                  </a>
                </div>

                <div className="branch-item">
                  <a
                    href="https://shopdunk.com/khuyen-mai"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Xem khuyến mãi"
                  >
                    <img src={branch6} alt="" width="100%" />
                  </a>
                </div>
                {/* <div className="branch-item"><img src={branch7} alt="" width="100%" /></div> */}
              </Slider>
            </div>
          </section>

          {/* -------------------------------- DUO --------------------------------*/}
          <section
            ref={iPhoneDuoRef}
            className="section-content-oversized dark"
          >
            <ProductSection
              product={iPhoneDuo}
              prodLink={iPhoneDuo.prodLink}
              preLink={iPhoneDuo.preLink}
              onClickRegister={handleOpenRegistration}
              theme={"dark"}
              colorText="black"
              conDetail="isDuo"
              isPrePage={true}
              isduo={true}
              setProductConfigs={setProductConfigs}
              setOpenModal={setOpenModal}
            />
          </section>

          {/* -------------------------------- PRO MAX --------------------------------*/}
          <section
            ref={iPhoneProMaxRef}
            className="section-content-oversized light"
          >
            <ProductSection
              product={iPhone18ProMax}
              prodLink={iPhone18ProMax.prodLink}
              preLink={iPhone18ProMax.preLink}
              onClickRegister={handleOpenRegistration}
              theme={"light"}
              colorText="black"
              isPrePage={true}
              conDetail={"isProMax"}
              setProductConfigs={setProductConfigs} //Chi tiếp sản phẩm popup
              setOpenModal={setOpenModal} //Chi tiếp sản phẩm popup
            />
          </section>

          {/* -------------------------------- PRO --------------------------------*/}
          <section className="section-content-oversized dark">
            <ProductSection
              product={iPhone18Pro}
              prodLink={iPhone18Pro.prodLink}
              preLink={iPhone18Pro.preLink}
              onClickRegister={() => { }}
              theme={"dark"}
              // indexPro={true}
              isplus={true}
              colorText="black"
              conDetail={"isPro"}
              isPrePage={true}
              setProductConfigs={setProductConfigs}
              setOpenModal={setOpenModal}
            />
          </section>

          {/* -------------------------------- AirPod 5 --------------------------------*/}
          <section className="section-content-oversized light">
            <Airpods
              productname={"AirPods 5"}
              productId={5397}
              productPrice={3790000}
              colorText="black"
              airpods4Url={"https://shopdunk.com/tai-nghe-airpods-5"}
              conDetail={"isAirPod"}
              setProductConfigs={setProductConfigs}
              setOpenModal={setOpenModal}
              handleOpenRegistration={handleOpenRegistration}
            />
          </section>

          {/* -------------------------------- Watch ultra 4 --------------------------------*/}
          <section
            ref={scrollTargetRef}
            className="section-content-oversized dark"
          >
            <WatchUltra4Section
              product={watchUltra4}
              prodLink={watchUltra4.prodLink}
              preLink={watchUltra4.preLink}
              onClickRegister={handleOpenRegistration}
              theme={"light"}
              colorText="black"
              conDetail={"watchul4"}
              isPrePage={true}
              setProductConfigs={setProductConfigs} //Chi tiếp sản phẩm popup
              setOpenModal={setOpenModal} //Chi tiếp sản phẩm popup
            />
          </section>

          {/* -------------------------------- Watch Series 12 --------------------------------*/}
          <section
            className="section-content-oversized light"
            style={{ position: "relative" }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingTop: "40px",
              }}
            >
              <button
                className={`btn_screen ${selectiPadAirM3 === 1 ? "selected" : ""}`}
                onClick={() => handleSiPadAirM311Inch(1)}
              >
                GPS
              </button>
              <button
                className={`btn_screen ${selectiPadAirM3 === 2 ? "selected" : ""}`}
                onClick={() => handleSiPadAirM311Inch(2)}
              >
                GPS + Cellular
              </button>
            </div>

            <div className="screens-wrapper" style={{ position: "relative" }}>
              <div
                className={`screen1 ${selectiPadAirM3 === 1 ? "active" : "exit"}`}
                style={{
                  zIndex: selectiPadAirM3 === 1 ? 1 : 0,
                  height: selectiPadAirM3 === 2 ? "0px" : "100%",
                }}
              >
                <WatchUltra4Section
                  product={watchSeries12Gps}
                  prodLink={watchSeries12Gps.prodLink}
                  preLink={watchSeries12Gps.preLink}
                  onClickRegister={handleOpenRegistration}
                  theme={"dark"}
                  colorText="black"
                  conDetail={"watchs12"}
                  isPrePage={true}
                  setProductConfigs={setProductConfigs} //Chi tiếp sản phẩm popup
                  setOpenModal={setOpenModal} //Chi tiếp sản phẩm popup
                />
              </div>

              <div
                className={`screen ${selectiPadAirM3 === 2 ? "active" : "exit"}`}
                style={{
                  zIndex: selectiPadAirM3 === 2 ? 1 : 0,
                  height: selectiPadAirM3 === 1 ? "0px" : "100%",
                }}
              >
                <WatchUltra4Section
                  product={watchSeries12Cellular}
                  prodLink={watchSeries12Cellular.prodLink}
                  preLink={watchSeries12Cellular.preLink}
                  onClickRegister={handleOpenRegistration}
                  theme={"dark"}
                  colorText="black"
                  conDetail={"watchs12"}
                  isPrePage={true}
                  setProductConfigs={setProductConfigs} //Chi tiếp sản phẩm popup
                  setOpenModal={setOpenModal} //Chi tiếp sản phẩm popup
                />
              </div>
            </div>
          </section>

          {/* Description */}
          <InfoTabs />

          {/* <ChatBoxFull /> */}
          <div className="footer-introduce desktop">
            <img src={image8} alt="" width="100%" />
          </div>

          <div className="footer-introduce mobile">
            <h3 className="tt-introduce">Tại sao nên mua hàng tại ShopDunk</h3>
            <div className="d-scroll">
              <img src={image9} alt="" width="1328px" />
            </div>
          </div>

          {/* Chi tiết sản phẩm */}
          <ModalProduct
            productConfigs={productConfigs}
            open={openModal}
            onClose={() => setOpenModal(false)}
          />

          {/* Đăng ký nhận tin */}
          <ModalRegistration
            open={openRegistration}
            onClose={() => handleCloseModal(false)}
            regProductId={regProductId}
          />
        </div>
      </div>
    </HomeStyled>
  );
}

export default Home;
